(function (root) {
  'use strict';

  var STORAGE_KEY = 'robot.measurementUnit.v1';
  var VALID_UNITS = { in: true, cm: true };
  var measurementPattern = /^\s*(\d+(?:\.\d+)?)\s*(?:["″]|in(?:ch(?:es)?)?)?\s*[x×]\s*(\d+(?:\.\d+)?)\s*(?:["″]|in(?:ch(?:es)?)?)?\s*$/i;
  var inchEvidence = /["″]|\bin(?:ch(?:es)?)?\b/i;

  function parseMeasurementLabel(value) {
    if (typeof value !== 'string' || !inchEvidence.test(value)) return null;
    var match = value.match(measurementPattern);
    if (!match) return null;
    var width = Number(match[1]);
    var height = Number(match[2]);
    if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return null;
    return [width, height];
  }

  function formatCentimeters(value) {
    var rounded = Math.round(value * 25.4) / 10;
    return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
  }

  function centimetersLabel(value) {
    var dimensions = parseMeasurementLabel(value);
    if (!dimensions) return null;
    return formatCentimeters(dimensions[0]) + ' × ' + formatCentimeters(dimensions[1]) + ' CM';
  }

  function safeStoredUnit() {
    try {
      var stored = root.localStorage && root.localStorage.getItem(STORAGE_KEY);
      return VALID_UNITS[stored] ? stored : 'in';
    } catch (_error) {
      return 'in';
    }
  }

  function rememberUnit(unit) {
    if (!VALID_UNITS[unit]) return;
    try {
      if (root.localStorage) root.localStorage.setItem(STORAGE_KEY, unit);
    } catch (_error) {
      // Storage can be unavailable in private or hardened browsing contexts.
    }
  }

  function applyUnit(unit, scope) {
    if (!VALID_UNITS[unit] || !scope || !scope.querySelectorAll) return 0;
    var changed = 0;
    scope.querySelectorAll('[data-robot-measurement-text]').forEach(function (node) {
      var source = node.getAttribute('data-robot-measurement-source') || node.textContent || '';
      var metric = centimetersLabel(source);
      if (!metric) return;
      var visible = unit === 'cm' ? metric : source;
      if (node.textContent !== visible) {
        node.textContent = visible;
        changed += 1;
      }
      var label = node.closest && node.closest('label');
      if (label && label.htmlFor && root.document) {
        var input = root.document.getElementById(label.htmlFor);
        if (input) input.setAttribute('aria-label', visible);
      }
    });
    scope.querySelectorAll('[data-robot-print-unit-select]').forEach(function (select) {
      if (select.value !== unit) select.value = unit;
      select.setAttribute('aria-label', unit === 'cm' ? 'Display product measurements in centimeters' : 'Display product measurements in inches');
    });
    if (root.document && root.document.documentElement) {
      root.document.documentElement.setAttribute('data-robot-measurement-unit', unit);
    }
    return changed;
  }

  var api = {
    storageKey: STORAGE_KEY,
    parseMeasurementLabel: parseMeasurementLabel,
    centimetersLabel: centimetersLabel,
    applyUnit: applyUnit
  };
  root.RobotPrintUnits = api;
  if (!root.document || !root.document.addEventListener) return;

  function activate() {
    var unit = safeStoredUnit();
    applyUnit(unit, root.document);
    root.document.addEventListener('change', function (event) {
      var select = event.target && event.target.closest && event.target.closest('[data-robot-print-unit-select]');
      if (!select || !VALID_UNITS[select.value]) return;
      unit = select.value;
      rememberUnit(unit);
      applyUnit(unit, root.document);
      root.document.dispatchEvent(new CustomEvent('robot:measurement-unit-change', { detail: { unit: unit } }));
    });
    if (root.MutationObserver && root.document.body) {
      new root.MutationObserver(function () { applyUnit(unit, root.document); })
        .observe(root.document.body, { childList: true, subtree: true });
    }
    root.addEventListener('storage', function (event) {
      if (event.key === STORAGE_KEY && VALID_UNITS[event.newValue]) {
        unit = event.newValue;
        applyUnit(unit, root.document);
      }
    });
  }

  if (root.document.readyState === 'loading') {
    root.document.addEventListener('DOMContentLoaded', activate, { once: true });
  } else {
    activate();
  }
})(typeof window !== 'undefined' ? window : globalThis);
